import React from 'react';

const Checkout = ({
  handleChange,
}) => (
  <div className="payment">
    <input type="text" className="input" 
      placeholder="Credit Card Number"/>
    <input type="text" className="input" 
      placeholder="Cardholder Name"/>
    <div className="columns">
      <div className="column">
        <input type="text" className="input" 
          placeholder="Expiration Date"/>
      </div>
      <div className="column">
        <input type="text" className="input" 
          placeholder="CVC"/>
      </div>
    </div>
    {/* <div>Campaign cost</div> */}
    <button className="button button--full">Confirm Payment</button>
  </div>
)

export default Checkout


// WEBPACK FOOTER //
// ./src/components/campaigns/Checkout.js